import React from 'react';
import { ChevronRight } from 'lucide-react';
import { FunnelStage } from '../data/mockData';
interface ConversionFunnelProps {
  funnel: FunnelStage[];
}
export function ConversionFunnel({
  funnel
}: ConversionFunnelProps) {
  const getStatusColors = (status: 'green' | 'yellow' | 'red') => {
    switch (status) {
      case 'green':
        return 'bg-emerald-500/10 border-emerald-500/30 text-emerald-400';
      case 'yellow':
        return 'bg-amber-500/10 border-amber-500/30 text-amber-400';
      case 'red':
        return 'bg-red-500/10 border-red-500/30 text-red-400';
    }
  };
  const getStatusIndicator = (status: 'green' | 'yellow' | 'red') => {
    switch (status) {
      case 'green':
        return 'bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.6)]';
      case 'yellow':
        return 'bg-amber-500 shadow-[0_0_8px_rgba(245,158,11,0.6)]';
      case 'red':
        return 'bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.6)]';
    }
  };
  return <section className="bg-slate-800/60 border border-slate-700/50 rounded-xl p-6 h-full flex flex-col" data-id="element-6">
      <div className="flex justify-between items-center mb-6" data-id="element-7">
        <h2 className="text-lg font-semibold text-white flex items-center gap-2" data-id="element-8">
          <span className="w-1.5 h-5 bg-blue-500 rounded-full" data-id="element-9"></span>
          Conversion Pipeline
        </h2>
        <div className="flex gap-3 text-xs text-slate-400" data-id="element-10">
          <div className="flex items-center gap-1" data-id="element-11">
            <div className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-12"></div> Strong
          </div>
          <div className="flex items-center gap-1" data-id="element-13">
            <div className="w-2 h-2 rounded-full bg-amber-500" data-id="element-14"></div> Average
          </div>
          <div className="flex items-center gap-1" data-id="element-15">
            <div className="w-2 h-2 rounded-full bg-red-500" data-id="element-16"></div> Weak
          </div>
        </div>
      </div>

      <div className="flex-1 flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-0" data-id="element-17">
        {funnel.map((stage, index) => <div key={stage.name} className="flex items-center w-full sm:w-auto flex-1" data-id="element-18">
            <div className={`relative flex-1 flex flex-col items-center justify-center p-4 rounded-lg border ${getStatusColors(stage.status)} transition-all duration-300 hover:bg-opacity-20`} data-id="element-19">
              <div className={`absolute top-2 right-2 w-2 h-2 rounded-full ${getStatusIndicator(stage.status)}`} data-id="element-20"></div>
              <span className="text-slate-300 text-xs sm:text-sm font-medium mb-1 text-center" data-id="element-21">
                {stage.name}
              </span>
              <span className="text-2xl sm:text-3xl font-bold" data-id="element-22">
                {stage.percentage}%
              </span>
            </div>

            {index < funnel.length - 1 && <div className="hidden sm:flex items-center justify-center w-8 text-slate-600" data-id="element-23">
                <ChevronRight className="w-6 h-6" data-id="element-24" />
              </div>}
            {index < funnel.length - 1 && <div className="sm:hidden flex items-center justify-center h-6 text-slate-600 my-1" data-id="element-25">
                <ChevronRight className="w-5 h-5 rotate-90" data-id="element-26" />
              </div>}
          </div>)}
      </div>
    </section>;
}